import React, {useMemo} from "react";
import HighchartsReact from "highcharts-react-official";
import {useTranslation} from "react-i18next";
import { lightBlue, lime } from '@mui/material/colors'

import Highcharts, {chartLogoOptions, creditsOptions, exportingOptions} from "../highChartsBase";
import useHighChartLocaleOptions from "../useHighChartLocaleOptions";
import Stack from "@mui/material/Stack";

const TimeserieTempGraph = ({data, station, highlightedDate}) => {
    const {t} = useTranslation("graphs");
    const highChartLocaleOptions = useHighChartLocaleOptions();

    const options = useMemo(() => {
        const xAxis = {
            type: 'datetime',
            gridLineWidth: 1
        };

        if (highlightedDate) {
            xAxis.plotLines = [{
                color: 'red',
                value: new Date(highlightedDate).getTime(),
                width: 1,
                dashStyle: 'Dash',
                zIndex: 5,
                label: {
                    text: '',
                    style: {
                        color: 'red',
                        fontWeight: 'bold'
                    }
                }
            }];
        }

        return {
            ...highChartLocaleOptions,
            exporting: {
                ...exportingOptions.exporting,
                filename: `${station?.code ?? 'model1'}_temp`
            },
            title: {
                text: `${station?.code ?? ''} - ${station?.name ?? ''} (${station?.elevation ?? '----'} m)`,
            },
            subtitle: {
                text: t('tempGraph.title'),
            },
            series: [
                {
                    data: data.map(item => [item.timestamp.getTime(), item.ta ?? null]),
                    type: 'spline',
                    name: t('tempGraph.legend.ta'),
                    color: lightBlue[500],
                },
                {
                    data: data.map(item => [item.timestamp.getTime(), item.th10 ?? null]),
                    type: 'spline',
                    name: t('tempGraph.legend.th10'),
                    color: lime[400],
                },
                {
                    data: data.map(item => [item.timestamp.getTime(), item.th30 ?? null]),
                    type: 'spline',
                    name: t('tempGraph.legend.th30'),
                    color: lime[900],
                },
            ],
            xAxis: xAxis,
            yAxis: [
            {
                title: {
                    text: 'TA [°C]'
                },
                gridLineWidth: 1
            },
        ],
        tooltip: {
            shared: true,
            crosshairs: true,
            xDateFormat: '%Y-%m-%d %H:%M'
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: true,
                    radius: 2,
                    symbol: 'circle',
                },
                spline: {
                    connectNulls: false,
                },
                states: {
                    hover: {
                        enabled: false
                    }
                }
            },
        },
        chart: {
            zoomType: 'x',
            height: 500,
            ...chartLogoOptions,
        },
        ...creditsOptions,
    };
    }, [data, highChartLocaleOptions, t, highlightedDate]);

    return <Stack>
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    </Stack>
}

export default TimeserieTempGraph;
